module.exports = __webpack_public_path__ + "img/wrong-tick.ece8207d.svg";